var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"return-image"},[_c('div',{staticClass:"circle"},[_c('CloudLeft',{staticClass:"cloud-left"}),_c('CloudRight',{staticClass:"cloud-right"}),_c(_vm.activeIllustration,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }